var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-table',{attrs:{"striped":"","hover":"","borderless":"","responsive":"","sticky-column":"","items":_vm.models}})}
var staticRenderFns = []

export { render, staticRenderFns }